import { FormattedMessage, useIntl } from 'react-intl';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { faShieldCheck } from '@fortawesome/pro-regular-svg-icons/faShieldCheck';
import { faVideo } from '@fortawesome/pro-regular-svg-icons/faVideo';
import { cn } from '@osmosis/tailwind-ui/helpers/classes';
import { text4 } from '@osmosis/tailwind-ui/styles/text';

/**
 * Trust strip shown below the hero input in the new Search/AI Chat design
 * (Figma 855-572 / 872-724).
 */
const DashboardSearchTrustStrip = () => {
  const intl = useIntl();

  return (
    <Flex
      data-testid="dashboard-search-trust-strip"
      className={cn(
        'my-2 items-center gap-2 self-start text-base font-bold leading-none',
        text4,
      )}
    >
      <Flex className="items-center gap-1.5">
        <Icon icon={faShieldCheck} className={text4} size={16} />
        <FormattedMessage
          id="dashboard.welcomeHeader.trustElsevier"
          defaultMessage="Grounded in trusted Elsevier medical content"
        />
      </Flex>
      <span aria-hidden="true">
        {intl.formatMessage({
          id: 'dashboard.welcomeHeader.trustSeparator',
          defaultMessage: '•',
        })}
      </span>
      <Flex className="items-center gap-1.5">
        <Icon icon={faVideo} className={text4} size={16} />
        <FormattedMessage
          id="dashboard.welcomeHeader.trustOsmosis"
          defaultMessage="Connected to Osmosis videos"
        />
      </Flex>
    </Flex>
  );
};

export default DashboardSearchTrustStrip;
